import {
  Box,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import React from 'react';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { useStyles } from '../../../../styles';

const SLATable = ({ onEdit, slaList }) => {
  const renderLocationChips = locations => {
    if (!locations || locations.length === 0) return '-';

    return (
      <Box display="flex" flexWrap="wrap" gap={0.5}>
        {locations.map((location, index) => (
          <Chip
            key={index}
            label={location}
            size="small"
            variant="outlined"
            style={{
              backgroundColor: '#e3f2fd',
              borderColor: '#1976d2',
              color: '#1976d2',
              fontSize: '0.75rem',
              height: '24px',
            }}
          />
        ))}
      </Box>
    );
  };

  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          size="small"
          className={classes.table}
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow classes={{ root: classes.tableHead }}>
              <TableCell>
                <Typography
                  classes={{ root: classes.tableHeadCell }}
                  variant="subtitle2"
                >
                  Average user load
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  classes={{ root: classes.tableHeadCell }}
                  variant="subtitle2"
                >
                  Peak user load
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  classes={{ root: classes.tableHeadCell }}
                  variant="subtitle2"
                >
                  Availability
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  classes={{ root: classes.tableHeadCell }}
                  variant="subtitle2"
                >
                  User base location
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  classes={{ root: classes.tableHeadCell }}
                  variant="subtitle2"
                >
                  Percentage
                </Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {slaList?.map(sla => (
              <TableRow classes={{ root: classes.configTableRow }}>
                <TableCell
                  classes={{
                    root: classes.tableBodyCell,
                  }}
                >
                  <Typography variant="subtitle2">
                    {sla?.averageUserLoad}
                  </Typography>
                </TableCell>
                <TableCell classes={{ root: classes.tableBodyCell }}>
                  {sla?.peakUserLoad}
                </TableCell>
                <TableCell classes={{ root: classes.tableBodyCell }}>
                  {sla?.availability}
                </TableCell>
                <TableCell classes={{ root: classes.tableBodyCell }}>
                  {renderLocationChips(sla?.userBaseLocation)}
                </TableCell>
                <TableCell classes={{ root: classes.tableBodyCell }}>
                  {sla?.locationPercentages ? (
                    <Box display="flex" flexWrap="wrap" gap={0.5}>
                      {Object.entries(sla.locationPercentages).map(
                        ([location, percentage]) => (
                          <Chip
                            key={location}
                            label={`${location}: ${percentage}%`}
                            size="small"
                            style={{
                              backgroundColor: '#f3e5f5',
                              color: '#7b1fa2',
                              fontSize: '0.75rem',
                              height: '24px',
                            }}
                          />
                        ),
                      )}
                    </Box>
                  ) : (
                    sla?.percentage || '-'
                  )}
                </TableCell>
                <TableCell className={classes.actionButtonInTableCell}>
                  <IconButton
                    className={classes.actionButtonRun}
                    onClick={() => onEdit('editSLA', sla)}
                  >
                    <EditOutlinedIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SLATable;
